import { graphql } from '../../graphql/generated';

export const STALE_REQUEST_STATUS_QUERY = graphql(`
  query StaleRequestStatus($requestId: ID!) {
    request(id: $requestId) {
      id
      status
    }
  }
`);
